import { FeatureAppDefinition, FeatureServices, Logger } from '@feature-hub/core';
import { ReactFeatureApp } from '@feature-hub/react';
import React from 'react';
import {App} from './app';
import { FeatureServicesContext } from './use-feature-services';
import { TrackingManagerV1 } from '@volkswagen-onehub/tracking-service';
import { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import { BreadcrumbServiceV1 } from '@volkswagen-onehub/breadcrumb-service';
import { GetUserLocationManagerV1 } from '@volkswagen-onehub/user-location-manager';
import {HistoryServiceV2} from '@feature-hub/history-service';
import { FeatureappService } from '@volkswagen-onehub/featureapp-service';
import { CAFinanceProviderService, CAFinanceProviderState } from '@vw-marketing/vw-ca-types'
import { LayerManagerV27 } from '@volkswagen-onehub/layer-manager';
import { FaContentServiceV1 } from '@volkswagen-onehub/fa-content-service';
import { UserLocationContextProvider } from './UserLocation/UserLocationContext';
import { LayerContextProvider } from './Layers';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LocationContextProvider } from './UserLocation/LocationContext';
import { AppContext, FeatureAppConfig } from './app-context';

export interface StarterFeatureAppDependencies extends FeatureServices {
  readonly 'locale-service': LocaleServiceV1;
  readonly 'tracking': TrackingManagerV1;
  readonly 's2:logger'?: Logger;
  readonly 'breadcrumb-service'?: BreadcrumbServiceV1;
  readonly 'user-location-manager'?: GetUserLocationManagerV1;
  readonly 's2:history': HistoryServiceV2;
  readonly 'featureapp-service'?: FeatureappService;
  readonly 'finance-provider-service'?: CAFinanceProviderService<CAFinanceProviderState>;
  readonly 'layer-manager'?: LayerManagerV27;
  readonly 'fa-content-service'?: FaContentServiceV1;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      enabled: false,
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      retry: false
    }
  }
});

export const featureAppDefinition: FeatureAppDefinition<
  ReactFeatureApp,
  StarterFeatureAppDependencies
> = {
  dependencies: {
    featureServices: {
      'user-location-manager': '1.0.0',
    }
  },
  optionalDependencies: {
    featureServices: {
      'locale-service': '^1.1.0',
      'tracking': '^1.0.0',
      's2:logger': '^1.0.0',
      'breadcrumb-service': '^1.0.0',
      's2:history': '^2.0.0',
      'featureapp-service': '^1.0.0',
      'finance-provider-service': '^1.0.0',
      'layer-manager': '^2.0.0',
      'fa-content-service': '^1.0.0'
    },
  },

  create: ({featureServices, config}) => ({
    render() {
      console.log("feature app config", config);
      return (
        <AppContext.Provider value={config as FeatureAppConfig}>
          <FeatureServicesContext.Provider value={featureServices}>
            <LayerContextProvider>
              <QueryClientProvider client={queryClient}>
                <LocationContextProvider>
                  <UserLocationContextProvider>
                    <App />
                  </UserLocationContextProvider>
                </LocationContextProvider>
              </QueryClientProvider>
            </LayerContextProvider>
          </FeatureServicesContext.Provider>
        </AppContext.Provider>
      );
    },
  }),
};

export default featureAppDefinition;
